// src/env.ts
type RuntimeEnv = Partial<Record<string, string>>;

function runtimeEnv(): RuntimeEnv {
  return (globalThis as any).__ENV || {};
}

export function envString(key: string, fallback?: string): string | undefined {
  const r = runtimeEnv()[key];
  if (r !== undefined && r !== "") return r;

  const v = (import.meta as any).env?.[key];
  if (v !== undefined && v !== "") return v;

  return fallback;
}

export function envRequired(key: string): string {
  const v = envString(key);
  if (!v) {
    // Fail fast + loud (dev + prod)
    throw new Error(
      `[config] Missing required environment variable: ${key}. ` +
        `Set it via K8s Secret / docker-compose env or Vite build env.`,
    );
  }
  return v;
}

export function envBool(key: string, fallback = false): boolean {
  const v = envString(key);
  if (v === undefined) return fallback;
  return ["1", "true", "yes", "on"].includes(String(v).toLowerCase());
}
